export default __webpack_public_path__ + "images/screenshot-search-2x-a440714.webp";